Property_channels = {
	init : function()
	{
		jQuery('.oc-property-channels.oc-carousel .oc-property-channels-list').on('init', function(event, slick){
			jQuery('.oc-property-channels.oc-carousel .oc-property-channels-list').addClass('initialised');
		});
		
		jQuery('.oc-property-channels.oc-carousel .oc-property-channels-list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			infinite: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				}
			]
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	Property_channels.init();
	
});